<template>
  <v-data-table
    :headers="headers"
    :items="stockTypes"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="StockType-button-new"
          :to="{
            name: 'processing-EditStockType'
          }"
        >
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        :data-cy="`button-StockType-edit-${item.id}`"
        @click="$router.push({
          name: 'processing-EditStockType',
          query: {id: item.id}
        })"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="remove(item)"
        color="danger"
        :data-cy="`button-StockType-remove-${item.id}`"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListStockType',
  module: 'StockType',
  mixins: [loading],
  computed: {
    /** Vuex states
     */
    ...mapState('stockTypes', ['stockTypes']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('name'),
          value: 'name',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_stockTypes();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('stockTypes', ['LOAD_stockTypes', 'DELETE_stockType']),
    /** Delete StockType from the collection
     */
    async remove(StockType) {
      this.isLoading = true;
      await this.DELETE_StockType(StockType);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# StockType example

'''js
<StockType />
'''
</docs>
